"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_final_form_1 = require("react-final-form");
var SelectButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/SelectButton"));
var FieldDropzone_1 = __importDefault(require("components/Form/FieldDropzone"));
var acceptedFileTypes = {
    'application/pdf': ['.pdf'],
    'application/csv': ['.csv'],
    'text/csv': ['.csv'],
};
var UploadLatestInvoice = function (_a) {
    var selectedVendor = _a.selectedVendor;
    var onSubmit = function (values) { console.log(values); };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ width: 320 }, { children: (0, jsx_runtime_1.jsx)(SelectButton_1.default, { isSelected: true, logoUrl: selectedVendor.logoUrl, label: selectedVendor.name }) })), (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit }, { children: function () { return ((0, jsx_runtime_1.jsx)(FieldDropzone_1.default, { name: "uploadedDocsFiles", maxFiles: 1, accept: acceptedFileTypes, boxStyles: { minHeight: 100, mx: 'auto' } })); } }))] }));
};
exports.default = UploadLatestInvoice;
